import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { ChevronDown, Check } from 'lucide-react';

// MultiSelect Component for multiple selection filters
const MultiSelect = ({ selected, onChange, options, placeholder, className, testId }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { tt } = useLanguage();
  const selectedValues = Array.isArray(selected) ? selected : [];

  const handleToggle = (optionValue) => {
    const newValues = selectedValues.includes(optionValue)
      ? selectedValues.filter(v => v !== optionValue)
      : [...selectedValues, optionValue];
    onChange(newValues);
  };

  const getDisplayText = () => {
    if (selectedValues.length === 0) return placeholder;
    if (selectedValues.length === 1) {
      const option = options.find(opt => (opt.value || opt) === selectedValues[0]);
      return option ? (option.label || option) : selectedValues[0];
    }
    return `Выбрано: ${selectedValues.length}`;
  };

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className={`form-input text-left flex justify-between items-center ${className || ''}`}
        data-testid={testId}
      >
        <span className={selectedValues.length === 0 ? 'text-gray-500' : ''}>
          {getDisplayText()}
        </span>
        <ChevronDown className="w-4 h-4 text-gray-400" />
      </button>
      
      {isOpen && (
        <>
          <div 
            className="fixed inset-0 z-10" 
            onClick={() => setIsOpen(false)}
          />
          <div className="absolute z-20 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-y-auto">
            {options.map((option, index) => {
              const optionValue = option.value || option;
              const optionLabel = option.label || option;
              const isSelected = selectedValues.includes(optionValue);
              
              return (
                <div
                  key={index}
                  onClick={() => handleToggle(optionValue)}
                  className={`px-3 py-2 text-sm cursor-pointer flex items-center hover:bg-gray-100 ${
                    isSelected ? 'bg-blue-50 text-blue-600' : 'text-gray-900'
                  }`}
                >
                  <div className={`w-4 h-4 mr-2 border rounded flex-shrink-0 ${
                    isSelected ? 'bg-blue-600 border-blue-600' : 'border-gray-300'
                  }`}>
                    {isSelected && (
                      <Check className="w-3 h-3 text-white m-0.5" />
                    )}
                  </div>
                  {optionLabel}
                </div>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
};

export default MultiSelect;